<div class="page-outer-wrapper">
  <div class="page-header">
    <div class="hamburger">
      <a routerLink="/overwatch"><img src="/assets/images/apple-touch-icon-72x72-precomposed.png" height="28" width="28"></a>
    </div>
    <div id="nav-bar" class="nav-bar">
    </div>
  </div>
  <div class="page-content-background">
    <div class="page-content">

      <br/>

      <div style="text-align: center;">

      <h2>Railviewer Privacy Policy</h2>

      <p>Type of website:  Visual viewing of railway infrastructure<</p>

      <p>Effective date: 26th day of October 2022</p>

      <p>https://railviewer.ironroad.ca (the "Site") is owned and operated by Iron Road Software & Simulations.</p>

      </div>


      <div style="padding: 12px;">

      <h4>Purpose</h4>

      <p>The purpose of this privacy policy (this "Privacy Policy") is to inform users of our Site of the following:</p>

      <ul>
      <li>Consent;</li>
      <li>Data collection; and</li>
      <li>Contact Information.</li>
      </ul>

      <p>This Privacy Policy applies in addition to the terms and conditions of our Site.</p>


      <h4>Consent</h4>

      <p>By using our Site users agree that they consent to the conditions set out in this Privacy Policy.</p>


      <h4>Data Collected by Site</h4>

      <p>No personal data is collected from Railviewer.  Using Google’s OAuth consent screen, the user’s email address is verified against the user’s password via Google.</p>


      <h4>Contact Information</h4>

      <p>If you have any questions, concerns, or complaints you can contact us via email at info&#64;ironroad.ca</p>

      </div>






    </div>

  </div>

</div>
